import type {CohortErrorCode} from '@cohort/shared/schema/common/errors';

export class CohortError extends Error {
  public code: CohortErrorCode;
  public context: Record<string, unknown>;

  public constructor(
    code: CohortErrorCode,
    message: string,
    context: Record<string, unknown> = {}
  ) {
    super(message);
    this.name = 'CohortError';
    this.code = code;
    this.context = context;
  }
}

export function toCohortError(err: unknown): err is CohortError {
  return err instanceof CohortError;
}

export function isCohortError(err: unknown, code?: CohortErrorCode): err is CohortError {
  return err instanceof CohortError && (code === undefined || err.code === code);
}
